export default {
  MSG_QUERY_FULL_FEATURE_UNAVAILABLE: '制限モードでは実行できません。',
  MSG_QUERY_FULL_FEATURE_UNAVAILABLE_DETAIL:
    '分析を行ってから一定期間経過している場合、制限モードでの閲覧のみ行うことができます。\n制限モードでは顧客選択などの一部機能がご利用いただけません。',
}
